import { FormField } from '../../../types/form-builder.types';
import { Input } from '@shondalai/ui-commons';

interface CalculationFieldProps {
  field: FormField;
  value: string | number;
  onChange: (value: any) => void;
  error?: string;
}

export function CalculationField({ field, value }: CalculationFieldProps) {
  const config = field.config;

  return (
    <div className="easyforms-calculation-field">
      <Input
        id={field.id}
        type="text"
        value={value || ''}
        disabled={true}
        readOnly={true}
        className="bg-muted cursor-not-allowed"
      />
      <p className="text-xs text-muted-foreground mt-1">
        {config.helpText || 'This field is calculated automatically'}
      </p>
    </div>
  );
}


